<template>
  <NuxtImg
    src="/images/icons/reviewio-star.webp"
    loading="eager"
    width="16"
    height="16"
    alt="reviewio star icon"
  />
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
